import { useResetTimer } from '@/hooks/useResetTimer'
import { useOfferReset } from '@/hooks/useOfferReset'
import { getNextResetUTC } from '@/utils/timer'
import { resetLabel } from '@/utils/reset-time'
import { ResetTimeTag } from './ResetTimeTag'

/**
 * The reset countdown in the page header, for the offer currently on screen.
 *
 * Renders the shared `ResetTimeTag` — the same chip admin-dashboard shows on `/cap`, and the same
 * one the offer tabs below use. It used to be two separate pills here ("Reset HH:MM:SS" and
 * "Resets at …"), which said the same thing as admin in a different shape; affiliates and admins
 * quote these numbers to each other, so the shapes now match.
 *
 * Offers do not share a reset — each rolls over at its own hour in its own zone — so the target
 * comes from the server's per-offer answer (`overflow_window.resets_at_utc`) rather than being
 * derived as the next midnight UTC.
 */
export function ResetTimer() {
  const { hours, minutes, seconds } = useResetTimer()
  const { nextReset, zone, hour } = useOfferReset()

  const resetAt = getNextResetUTC(nextReset)
  // `useResetTimer` already ticks once a second; hand it straight to the tag rather than letting
  // the tag start a second interval against the same instant.
  const countdownMs = ((hours * 60 + minutes) * 60 + seconds) * 1000

  return (
    <ResetTimeTag
      resetAt={resetAt}
      countdownMs={countdownMs}
      // The offer's OWN clock is the third frame of reference — worth having when reconciling with
      // an account manager, but not worth a third number on screen, so it lives in the tooltip.
      // Same placement as admin's tag.
      title={`Cap day rolls over at ${resetLabel(zone, hour)}${zone ? ` (${zone})` : ''}`}
    />
  )
}
